import { createApp } from "vue";
import vuei18n from "@/i18n";
import ModelConflictScreen from "./ModelConflictScreen.vue";
import type { Model } from "@/api/Model";

/**
 * Show a popup to resolve conflict cases
 */
export async function showConflictModelPopup(
  localModel: Partial<Model>,
  remoteModel: Partial<Model> | undefined,
  conflictType = "model"
) {
  console.log("local", localModel);
  console.log("remote", remoteModel);

  return new Promise((resolve, reject) => {
    try {
      const mountElement = document.createElement("div");
      const instance = createApp(ModelConflictScreen, {
        localModel: localModel,
        remoteModel: remoteModel,
        conflictType,
        onClose: (action: unknown) => {
          instance.unmount();
          mountElement.remove();
          resolve(action);
        }
      });
      instance.use(vuei18n);
      instance.mount(mountElement);
      document.body.appendChild(mountElement);
    } catch (error) {
      reject(error);
    }
  });
}
